/**
 * @flow
 * @format
 */

import React from 'react';
import { connect } from 'react-redux';
import { compose, pure } from 'recompose';
import { Card, Row, Col, Button } from 'reactstrap';
import cc from 'classcat';

import FaFilePdfO from 'react-icons/lib/fa/file-pdf-o';
import FaSpinner from 'react-icons/lib/fa/spinner';

import { actions as designActions } from '~/actions/design';
import { getReportPDF } from '~/selectors/design';

import { branch } from '~/utils';
// import debug from '~/utils/macros/debug.macro';

import classes from './ExportReportWrapper.scss';

type PropsType = {
  loading: boolean,
  onDownloadPDF: Function,
};

// eslint-disable-next-line react/prefer-stateless-function
export class ExportReportWrapper extends React.Component<PropsType, *> {
  static defaultProps = {};

  props: PropsType; // eslint-disable-line react/sort-comp

  render() {
    return (
      <Row>
        <h4 className={cc(['col col-sm-12', classes.cardHeader])}>
          Export Report
        </h4>
        <Col>
          <Card body className="p-4">
            <Row style={{ height: '150px' }}>
              <Col sm={12}>
                <p>
                  Your report is ready to be generated. Click the button below
                  to download the PDF.
                </p>
              </Col>
              <Col>
                <p>
                  <Button
                    size="md"
                    disabled={this.props.loading}
                    onClick={this.props.onDownloadPDF}
                  >
                    {branch(this.props.loading, <FaSpinner />, <FaFilePdfO />)}
                    {'   '}
                    {branch(
                      this.props.loading,
                      'Fetching Report',
                      'Generate Report',
                    )}
                  </Button>
                </p>
                <p>Note: this may take some time to complete.</p>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = (state: AppStateType): {} => {
  const reportData = getReportPDF(state);

  return {
    loading: reportData.loading,
  };
};

function mapDispatchToProps(dispatch: AppDispatch): {} {
  return {
    onDownloadPDF: () => dispatch(designActions.requestPDF()),
  };
}

const enhancer = compose(connect(mapStateToProps, mapDispatchToProps), pure);

export default enhancer(ExportReportWrapper);



// WEBPACK FOOTER //
// ./src/components/ExportReportWrapper/ExportReportWrapper.js